import React from 'react';
import Skills from '../Utils/skills';
import {Container} from 'react-bootstrap';

const SkillsComp = () => {
  // listen for scroll
  window.addEventListener('scroll', () => {
    const homeskillsContainer = document.querySelector(
      '.home_skills_container'
    );
    // window position
    let windowPosition = window.scrollY;
    // keyframes
    const fadeInLeft = [
      {transform: 'translateX(-100vw)', opacity: '0.3'},
      {transform: 'translate(0)', opacity: '1'},
    ];
    // options
    const timing = {
      duration: 1000,
    };

    if (windowPosition == 300) {
      homeskillsContainer.animate(fadeInLeft, timing);
    }
  });

  return (
    <section className="home_skills ">
      <Container className="home_skills_container d-flex flex-column align-items-center">
        <h5
          style={{
            opacity: '.5',
          }}
          className="fw-semibold">
          Current Tech Stack {'|'}{' '}
        </h5>
        <Skills />
      </Container>
    </section>
  );
};

export default SkillsComp;
